'use strict';

var isInteger = require('is-integer');

module.exports = function isValidMonth(month) {
  if (typeof month !== 'number' || !isInteger(month)) return false;
  return month >= 1 && month <= 12;
};